import { createContext, useContext } from 'react'

export const FilmDownloadContext = createContext({
  downloads: { current: {} },
  downloadHandlers: {},
})

export const useFilmDownloads = () => useContext(FilmDownloadContext)
